import { IS_PRODUCTION } from "./environment";

// Partner ids must match the records graphql-api resolves from
// `providers.partners`, and the ids future-money-mobile carries. A mismatch
// leaves the user holding a partner id the client does not recognise, and the
// experience silently never shows.
export const partnerBanks = {
  mnt: {
    partnerId: IS_PRODUCTION
      ? "01a00084-2f8d-7b96-babd-f20d309dca62"
      : "01a0008b-edd0-761e-a322-f2c98aa01a02",
  },
  flb: {
    partnerId: IS_PRODUCTION
      ? "01a0f775-6388-7ddc-b91c-95dddd56228d"
      : "01a0f777-b432-712c-8a0d-1c1f6a8345ba",
  },
  armstrong: {
    partnerId: IS_PRODUCTION
      ? "01a0f77b-fa44-7c28-aba7-c2e2471bbcba"
      : "01a0f77b-3bc3-772c-bf0b-780c74b54736",
  },
  umb: {
    partnerId: IS_PRODUCTION
      ? "01a0f77c-880a-7ecb-b805-7b153144dbb7"
      : "01a0f77d-009d-7fbf-b10f-a5dc9603f9d5",
  },
  greatPlains: {
    partnerId: IS_PRODUCTION
      ? "01a0f77e-5049-7579-b224-c85fad452273"
      : "01a0f77d-d5cc-77c0-8650-e641e5cb8fcb",
  },
  firstOklahoma: {
    partnerId: IS_PRODUCTION
      ? "01a0f780-0e4a-7183-acbd-a19d9e9e563a"
      : "01a0f781-f256-7ea2-a07e-aa5ea7b8ff62",
  },
  weokie: {
    partnerId: IS_PRODUCTION
      ? "01a0fe30-b11b-7c7a-9a8c-90e06f9031ab"
      : "01a0fe33-05a0-7d5a-9573-74bd6031231f",
  },
};
